<template>
  <svg-icon type="mdi" :path="path" :size="size"></svg-icon>
</template>

<script setup>
import { ref } from 'vue'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiChartTimelineVariant } from '@mdi/js'
const path = ref(mdiChartTimelineVariant)

defineProps({
      size: {
          type: Number,
          default: 14,
      }
  })
</script>
